module.exports = __webpack_public_path__ + "media/homeProperty/Location-16e4338b.png";